import { render, staticRenderFns } from "./GSchoolClassCheckboxes.vue?vue&type=template&id=2dfbc493&scoped=true&"
import script from "./GSchoolClassCheckboxes.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassCheckboxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbc493",
  null
  
)

export default component.exports